import { CommonModule } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import { Component, HostListener, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule, ModalController } from "@ionic/angular";
import { TranslocoModule } from "@ngneat/transloco";
import { ApiService } from "source/app/configuration/services/api.service";

@Component({
	selector: "app-key-warning",
	templateUrl: "./key-warning.component.html",
	standalone: true,
	styleUrls: ["./key-warning.component.scss"],
	imports: [CommonModule, IonicModule, TranslocoModule, FormsModule],
})
export class KeyWarningComponent {
	static modalId = "key-warning-component";

	constructor(
		private modalController: ModalController,
		private apiService: ApiService,
	) {}

	@Input() location: string;

	rideOpsKey: string = "";
	testing: boolean = false;
	keyTestResult: keyTestResult;
	errorText: string = "";

	@HostListener("keydown.enter")
	protected enter = async () => {
		if (this.rideOpsKey == null || this.rideOpsKey.length <= 0 || this.testing) {
			return;
		}
		this.testing = true;

		const keyTestResult = await this.testKey(this.rideOpsKey, this.location);
		if (keyTestResult === "WORKS") {
			this.modalController.dismiss(this.rideOpsKey);
		} else {
			this.keyTestResult = keyTestResult;
			this.rideOpsKey = "";
			this.testing = false;
		}
	};

	private testKey = async (key: string, location: string): Promise<keyTestResult> => {
		try {
			const response = await this.apiService.testRideOpsKey(location, key);
			if (response == null) {
				return "NO_ACCESS_FOR_LOCATION";
			}
			return "WORKS";
		} catch (exception) {
			if (exception instanceof HttpErrorResponse && exception.status === 401) {
				return "KEY_INVALID";
			}
			return "UNKNOWN";
		}
	};
}

type keyTestResult = "WORKS" | "NO_ACCESS_FOR_LOCATION" | "KEY_INVALID" | "UNKNOWN";
